import(/* webpackMode: "eager" */ "/codebuild/output/src1142338333/src/apps/jumplab/src/app/error.tsx");
